import { useState } from 'react';
import { useIntl } from '@leagueplatform/locales';
import { STEP_STRING_IDS } from 'components/onboarding-account-setup/onboarding-account-setup.constants';
import { StepScreen } from 'components/step-screen/step-screen.component';
import { useStepNavigation } from 'components/stepper/stepper.component';
import { useOnboardingError } from 'components/onboarding-account-setup/contexts/onboarding-error.context';
import {
  useOnboardingFormActions,
  useOnboardingFormState,
} from 'components/onboarding-account-setup/contexts/onboarding-form.context';
import { MobileNumberInput } from './mobile-number-input.component';

export const MobileNumberStep = () => {
  const { formatMessage } = useIntl();
  const { goToNextStep, goToPreviousStep } = useStepNavigation();
  const { reportError } = useOnboardingError();
  const {
    formState: { mobileNumber, mobileNumberError },
    requestOtpStatus: { isPending },
  } = useOnboardingFormState();
  const { handleMobileNumberChange, submitMobileNumber } =
    useOnboardingFormActions();
  const [serverErrorMessage, setServerErrorMessage] = useState<string>();

  const handleNumberChange = (value: string) => {
    setServerErrorMessage(undefined);
    handleMobileNumberChange(value);
  };

  const handleSubmit = async () => {
    setServerErrorMessage(undefined);

    try {
      const result = await submitMobileNumber();
      if (!result) return;

      if (result.success) {
        goToNextStep();
      } else {
        setServerErrorMessage(
          result.message ||
            formatMessage({
              id: 'STR_ONBOARDING_ACCOUNT_SETUP_VALIDATION_MOBILE_INVALID',
            }),
        );
      }
    } catch (err) {
      reportError(err as Error);
    }
  };

  return (
    <StepScreen
      heading={formatMessage({ id: STEP_STRING_IDS.mobile.heading })}
      primaryButton={{
        label: formatMessage({ id: STEP_STRING_IDS.mobile.primaryButtonLabel }),
        onClick: handleSubmit,
        isButtonLoading: isPending,
      }}
      secondaryButton={{
        label: formatMessage({
          id: STEP_STRING_IDS.mobile.secondaryButtonLabel,
        }),
        onClick: goToPreviousStep,
      }}
    >
      <MobileNumberInput
        value={mobileNumber}
        onChange={handleNumberChange}
        error={mobileNumberError}
        errorMessage={serverErrorMessage}
      />
    </StepScreen>
  );
};
